<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-button slot="append" type="primary" size="small" style="margin-bottom: 20px" @click="addKehuFn" >
            添加客户
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="custom_id"
          min-width="50" />
        <el-table-column
          label="客户名字"
          prop="custom_name"
          min-width="150" />
        <el-table-column
          label="客户电话"
          prop="custom_contact"
          min-width="150" >
          <template slot-scope="scope">
              {{scope.row.custom_contact ? scope.row.custom_contact : '--'}}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          min-width="150" />
        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small"  @click="editFn(scope.row)">修改</el-button>
            <el-button type="text" size="small"  @click="deleteFn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>


    <el-dialog
      :title="addType=='edit'?'编辑':'添加客户'"
      :visible.sync="addClientShow"
      width="30%"
      :before-close="handleClose">

      <div class="">
        <el-form :inline="true" class="demo-form-inline">
          <div style="display:flex;flex-direction: column">
            <el-form-item label="客户名字">
              <el-input v-model="formData.custom_name" placeholder="名字"></el-input>
            </el-form-item>
            <el-form-item label="客户电话">
              <el-input v-model="formData.custom_contact" placeholder="联系电话"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addClientShow = false">取 消</el-button>
        <el-button type="primary" @click="addClientFn">确 定</el-button>
      </span>
    </el-dialog>




    <el-dialog
      title="删除客户"
      :visible.sync="deleteShow"
      width="30%"
      :before-close="handleClose">
      <div class="">
        确定删除客户【{{deleteData.custom_name}}】
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteConfirmFn">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  // +----------------------------------------------------------------------
  // | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
  // +----------------------------------------------------------------------
  // | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
  // +----------------------------------------------------------------------
  // | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
  // +----------------------------------------------------------------------
  // | Author: CRMEB Team <admin@crmeb.com>
  // +----------------------------------------------------------------------
  import { roterPre } from '@/settings'
  import {fromList} from "@/libs/constants";
  import {
    recoveryStockCardListApi, customLst, stockSetUpdate , customCreate , customDelete
  } from "@/api/recovery";
  import cardsData from "@/components/cards";
  import {cardListApi} from "@/api/order";
  import {changeNowMoneyApi} from "@/api/user";
  export default {
    name: 'appraisalEntityOrder',
    components: {cardsData},
    computed:{
      maxFn(){
        return function (item,index) {
          let num = 0
          this.ruleForm.batch_list.map((item1,index1)=>{
            num+= item1.batch_num
          })
          return  this.ruleForm.stock - num + item.batch_num
        }
      }

    },
    data() {
      return {
        deleteData:{},
        deleteShow:false,
        itemList:[],
        props: { checkStrictly: true, emitPath: false},
        moren: require("@/assets/images/f.png"),
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        listLoading: true,
        tableData: {
          data: [],
          total: 0
        },
        roterPre: roterPre,
        tableFrom: {
          page: 1,
          limit: 20,
        },
        custom_id:0,
        addType:'add',
        orderChartType: {},
        fromList: fromList,
        cardLists: [],
        timeVal: [],
        dialogVisible:false,
        loading: false,
        formData: {},
        addClientShow:false,
        ruleForm:{
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        },
        appraisal_order_id:'',
        recoveryCateList:[],
      }
    },
    mounted() {
      this.getList(1)
      this.getCardList()
    },
    methods: {
      /**
       * 修改客戶
       * */
      editFn(row){
          this.addClientShow = true
          this.addType = 'edit'
          this.formData = JSON.parse(JSON.stringify(row))
      },
      deleteConfirmFn(){
        customDelete(this.deleteData.custom_id).then(res=>{
          this.getList()
          this.deleteShow = false
        }).catch(err=>{
          this.$message.error(err.message)
        })
      },
      /**
       * 删除客户
       * */
      deleteFn(row){
        this.deleteData = row
          this.deleteShow = true
      },
      /**
       * 添加客户
       * */
      async addClientFn(){
        if(!this.formData.custom_name){
          this.$message.error('请输入客户名字')
          return
        }
        if(!this.formData.custom_contact){
          this.$message.error('请输入客户电话')
          return
        }
        let id = this.formData.custom_id?this.formData.custom_id:null
        let data = await customCreate(id,this.formData)
        console.log(data)
        this.getList()
        this.addClientShow = false
      },
      addKehuFn(){
        this.formData = {}
        this.addType = 'add'
        this.addClientShow = true
      },
      /**
       * 增加批号
       * */
      addBatchFn(){
        let num = 0
        this.ruleForm.batch_list.map((item,index)=>{
          num+= item.batch_num
        })
        if(num < this.ruleForm.stock){
          this.ruleForm.batch_list.push({batch_number:'',batch_num: 1})
        }

      },
      /**
       * 修改库存
       */
      async batchConfirm(){
        /**
         * 判断批号是否输入完整
         * */
        if(this.ruleForm.batch_list.some((v,i)=>{if(!v.batch_number)return true}))
        {
          this.$message.error('请检查批号是否输入完整')
          return
        }
        if(this.ruleForm.type == 0){ // 减少库存的时候必传出库价格
          if(!this.ruleForm.outbound_price){
            this.$message.error('请输入出库价格')
            return
          }
        }

        let data = await stockSetUpdate(this.stockId,this.ruleForm)
        this.getList()
        this.handleClose()
      },
      handleClose(){
        this.dialogVisible = false
      },
      batchChange(e,index){
        if(e<=0){
          this.$nextTick(()=>{
            this.ruleForm.batch_list.splice(index,1)
          })
        }
      },
      // 选择时间
      selectChange(tab) {
        this.tableFrom.date = tab;
        this.tableFrom.page = 1;
        this.timeVal = [];
        this.getList(1);
      },
      // 具体日期
      onchangeTime(e) {
        this.timeVal = e;
        this.tableFrom.date = e ? this.timeVal.join("-") : "";
        this.tableFrom.page = 1;
        this.getList(1);
      },
      // 列表
      getList(num) {
        this.listLoading = true
        this.tableFrom.page = num ? num : this.tableFrom.page
        customLst(this.tableFrom).then(res => {
          this.tableData.data = res.data.list
          this.tableData.total = res.data.count
          this.listLoading = false
          this.getCardList()
        }).catch(res => {
          this.listLoading = false
          this.$message.error(res.message)
        })
      },
      pageChange(page) {
        this.tableFrom.page = page
        this.getList('')
      },
      handleSizeChange(val) {
        this.tableFrom.limit = val
        this.getList('')
      },
      getCardList(){
        recoveryStockCardListApi(this.tableFrom)
          .then((res) => {
            this.cardLists = res.data;
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      },
      // 修改余额
      setRecoveryStock(row) {
        this.dialogVisible = true
        this.stockId = row.recovery_stock_id
        this.ruleForm={
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .box-container {
    overflow: hidden;
  }
  .box-container .list {
    float: left;
    line-height: 40px;
  }
  .box-container .sp {
    width: 50%;
  }
  .box-container .sp3 {
    width: 33.3333%;
  }
  .box-container .sp100 {
    width: 100%;
  }
  .box-container .list .name {
    display: inline-block;
    width: 150px;
    text-align: right;
    color: #606266;
  }
  .box-container .list.image {
    margin-bottom: 40px;
  }
  .box-container .list.image img {
    position: relative;
    top: 40px;
  }
  /deep/.el-form-item__content .el-rate{
    position: relative;
    top: 8px;
  }
</style>
